import useAuthDialog from '@common/components/auth-dialog/useAuthDialog';
import { APP_SESSION } from '@common/constants';
import { useAppSelector } from '@common/hooks/store';
import config from '@config';
import { selectUserCurrencyCode, userLoggedIn } from '@features/auth/slice/authSlice';
import { useFetchInbetSessionQuery } from '@features/keno/api/kenoApi';
import Box from '@mui/material/Box';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';

const KenoIframe = () => {
  const { name } = useParams();
  const toggleDialog = useAuthDialog();
  const loggedIn = useAppSelector(userLoggedIn);
  const currencyCode = useAppSelector(selectUserCurrencyCode)!;
  const inbetSessionQuery = useFetchInbetSessionQuery();
  const urlInbetHost = config.inbetHost;
  const sessionToken = reactLocalStorage.get<string>(APP_SESSION);
  const homePage = `${window.location.origin}/keno-games`;
  const lang = 'ru_RU';
  const betPerLine = config.inbetBetPerLine[currencyCode];
  const inbetHost = new URL(urlInbetHost + '/game.html');
  if (name) inbetHost.searchParams.append('name', name);
  inbetHost.searchParams.append('b', config.inbet);
  inbetHost.searchParams.append('u', sessionToken);
  inbetHost.searchParams.append('c', currencyCode);
  inbetHost.searchParams.append('l', lang);
  inbetHost.searchParams.append('h', homePage);
  inbetHost.searchParams.append('kl', betPerLine.toString());

  useEffect(() => {
    const basket = document.querySelector('.mui__basket') as HTMLElement;
    if (basket) {
      basket.style.display = 'none';
    }

    return () => {
      if (basket) {
        basket.style.display = 'block';
      }
    };
  }, []);

  if (!loggedIn && !inbetSessionQuery.isSuccess) {
    toggleDialog(true);
  }

  return (
    <Box>
      <iframe
        src={inbetHost.toString()}
        title="Keno"
        style={{
          height: '100%',
          width: '100%',
          border: 'none',
          overflow: 'hidden',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        }}
      />
    </Box>
  );
};

export default KenoIframe;
